export default __webpack_public_path__ + "static/media/policewatch.a2360488.png";